import { MediaCollection, PaginatedResponse } from '@arpeggi/shared'
import axios from 'axios'
import { GetMediaCollectionParams } from '../../media-queries'

export const getMediaCollections = async (params: GetMediaCollectionParams) => {
  const { data } = await axios.get<PaginatedResponse<MediaCollection>>('/api/v2/media-collection', {
    params
  })

  return data
}
